
const getters = {
  hasZoomDevice: (_, getters) => {
    return getters.getSelectedPlans.some(plan => plan.isVendorProduct);
  }
}

export default {
  getters,
}
